import { Colors } from "@brg/ui";

export enum CoverType {
    BACHELORS_DEGREE = 'BachelorsDegree',
    MASTERS_DEGREE = 'MastersDegree',
    AUTHOR = 'author',
    DEFAULT = 'default'
}

export const getChannelColor = (type: string) => {
    switch(type) {
        case CoverType.BACHELORS_DEGREE:
            return Colors.hotRed1
        case CoverType.MASTERS_DEGREE:
            return Colors.defaultPurple3
        case CoverType.AUTHOR:
            return Colors.hotRed
        default:
            return Colors.galBlack47 
    }
}
import { Colors } from "@brg/ui";

export enum CoverType {
    BACHELORS_DEGREE = 'BachelorsDegree',
    MASTERS_DEGREE = 'MastersDegree',
    AUTHOR = 'author',
    DEFAULT = 'default'
}

export const getChannelColor = (type: string) => {
    switch(type) {
        case CoverType.BACHELORS_DEGREE:
            return Colors.hotRed1
        case CoverType.MASTERS_DEGREE:
            return Colors.defaultPurple3
        case CoverType.AUTHOR:
            return Colors.hotRed
        default:
            return Colors.galBlack47 
    }
}
